<template>
    <secition-card
        title="유입사이트"
        v-bind="{
            titleActionProps: { to: '/console/statistics/referrer' },
            loading,
        }"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";
import SecitionCard from "@/components/console/dumb/secition-card.vue";

export default {
    components: {
        SecitionCard,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        ranks: [],

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "도메인",
                    value: "_id",
                    formatter: (value) => value || "직접방문",
                },
                {
                    text: "유입수",
                    value: "count",
                    width: 100,
                    align: "end",
                    formatter: (value) => `${value.format()}건`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            return this.ranks || [];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;
                const { ranks } = await api.console.statistics.visits.gets({
                    params: { searchDateValue },
                    headers: { limit: 6, mode: "referrer-ranks" },
                });
                this.ranks = ranks;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style>
</style>